import { useCallback, useEffect, useState } from 'react'

import { useSearchParams } from 'react-router-dom'

import SummerDealUmbrella from '@/assets/images/summer-deal.png'

import { SummerDealDialog } from './dialogs/SummerDealDialog'

export const SummerDealButton = () => {
  const [params, setParams] = useSearchParams()
  const [isDialogOpen, setDialogOpen] = useState(false)

  useEffect(() => {
    const openChristmasPackage = params.get('openChristmasPackage')

    if (openChristmasPackage) {
      setDialogOpen(true)
      setParams({ openChristmasPackage: '' })
    }
  }, [params, setParams])

  const handleClick = useCallback(() => {
    setDialogOpen(true)
  }, [])

  const handleDialogClose = useCallback(() => {
    setDialogOpen(false)
  }, [])

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          // eslint-disable-next-line no-inline-styles/no-inline-styles
          background: 'linear-gradient(91.75deg, #FF4006 -0.05%, #395474 100%)',
        }}
        className="group relative flex h-[40px] w-[220px] items-center overflow-hidden rounded-md p-[1px] "
      >
        <div className="flex h-full w-full items-center justify-center rounded-md bg-primary-800 text-[18px] opacity-100 transition-opacity duration-1000 group-hover:opacity-0">
          <div className="relative pl-8 text-[16px] font-medium text-white">
            <img
              src={SummerDealUmbrella}
              alt=""
              className="absolute left-0 top-1/2 w-6 -translate-y-1/2"
            />
            End of Summer Offer
          </div>
        </div>
        <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center rounded-md opacity-0 transition-opacity duration-1000 group-hover:opacity-100">
          <div className="relative text-sm font-medium text-white">
            Claim now
          </div>
        </div>
      </button>
      <SummerDealDialog
        show={isDialogOpen}
        onClose={handleDialogClose}
      />
    </>
  )
}
